export class DoTrackInput {
  leadId?: string;
  onTrackStatus?: string;
  comments?: string;
}
